document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('tcb-contact-form-el');
  if (!form) return;

  var sec = window.TcbSecurity || {};
  var sanitize = sec.sanitizeQueryValue || function (value, maxLen) {
    var text = String(value == null ? '' : value).trim();
    return typeof maxLen === 'number' && maxLen > 0 ? text.slice(0, maxLen) : text;
  };

  var topicSelect = document.getElementById('tcb-contact-topic');
  var productInput = document.getElementById('tcb-contact-product');
  var firstNameInput = document.getElementById('tcb-contact-first-name');
  var lastNameInput = document.getElementById('tcb-contact-last-name');
  var fullNameInput = document.getElementById('tcb-contact-full-name');
  var messageInput = document.getElementById('tcb-contact-message');
  var honeypotInput = document.getElementById('tcb-contact-honeypot');

  var topicMap = {
    'expert-help': 'Expert equipment help',
    equipment: 'Expert equipment help',
    parts: 'Parts & supplies',
    shipping: 'Order & shipping',
    order: 'Order & shipping',
    returns: 'Returns & warranty',
    warranty: 'Returns & warranty',
    b2b: 'B2B / bulk quote',
    quote: 'B2B / bulk quote',
    financing: 'Financing',
    documents: 'Product documents & manuals',
    'price-match': 'B2B / bulk quote',
    'part-match': 'Parts & supplies',
    'package-builder': 'Equipment package quote',
    'fit-check': 'Expert equipment help',
    'complete-package': 'Equipment package quote',
    'equipment-package': 'Equipment package quote',
    'equipment-finder': 'Expert equipment help',
    'equipment-advisor': 'Equipment package quote'
  };

  var allowedTopics = {};
  if (topicSelect) {
    Array.prototype.forEach.call(topicSelect.options, function (option) {
      if (option.value) allowedTopics[option.value.toLowerCase()] = option.value;
    });
  }

  function scrollToForm() {
    var panel = document.getElementById('tcb-contact-form');
    if (!panel) return;
    var hash = window.location.hash;
    if (
      hash === '#tcb-contact-form' ||
      hash === '#tcb-contact-form-el' ||
      hash === '#tcb-finder-lead-form'
    ) {
      (document.getElementById('tcb-finder-lead-form') || panel).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function normalizeContactLanding() {
    var hash = window.location.hash;
    if (hash !== '#tcb-finder-lead-form') return;
    var search = window.location.search || '';
    if (search.indexOf('topic=') === -1) {
      search += (search ? '&' : '?') + 'topic=equipment-finder';
    }
    var next = window.location.pathname + search + hash;
    if (next !== window.location.pathname + window.location.search + window.location.hash) {
      history.replaceState(null, '', next);
    }
    setTopicFromParam('equipment-finder');
    scrollToForm();
  }

  function getQueryParam(key) {
    try {
      return new URLSearchParams(window.location.search).get(key);
    } catch (e) {
      return null;
    }
  }

  function setTopicFromParam(value) {
    if (!topicSelect || !value) return;
    var normalized = sanitize(value, 64).toLowerCase();
    var mapped = topicMap[normalized] || allowedTopics[normalized.toLowerCase()];
    if (!mapped) return;
    topicSelect.value = mapped;
  }

  function setFieldValue(id, value, maxLen) {
    var input = document.getElementById(id);
    var clean = sanitize(value, maxLen);
    if (input && clean) {
      input.value = clean;
    }
    return clean;
  }

  function applyPrefill(data) {
    if (!data || typeof data !== 'object') return;
    setTopicFromParam(data.topic);
    var productValue = setFieldValue('tcb-contact-product', data.product, 200)
      || setFieldValue('tcb-contact-product', data.model, 200)
      || setFieldValue('tcb-contact-product', data.sku, 120);
    setFieldValue('tcb-contact-company', data.company, 120);
    setFieldValue('tcb-contact-first-name', data.first_name, 80);
    setFieldValue('tcb-contact-phone', data.phone, 40);

    var emailValue = sanitize(data.email, 254);
    if (emailValue && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
      setFieldValue('tcb-contact-email', emailValue, 254);
    }

    if (messageInput && !sanitize(messageInput.value, 5000)) {
      if (data.description) {
        messageInput.value = sanitize(data.description, 5000);
      } else {
      var parts = [];
      if (data.part_number) parts.push('Part number: ' + sanitize(data.part_number, 120));
      if (data.make) parts.push('Make: ' + sanitize(data.make, 80));
      if (data.year) parts.push('Year: ' + sanitize(data.year, 20));
      if (data.serial) parts.push('Serial: ' + sanitize(data.serial, 80));
      if (data.description) parts.push('Details: ' + sanitize(data.description, 500));
      if (parts.length) {
        messageInput.value = parts.join('\n');
      } else if (productValue) {
        messageInput.placeholder = 'I have a question about ' + productValue + '…';
      }
      }
    }
  }

  try {
    var stored = sessionStorage.getItem('tcb-contact-prefill');
    if (stored) {
      applyPrefill(JSON.parse(stored));
      sessionStorage.removeItem('tcb-contact-prefill');
    }
  } catch (e) {
    /* ignore invalid storage payloads */
  }

  setTopicFromParam(getQueryParam('topic'));
  normalizeContactLanding();

  var returnInput = document.getElementById('tcb-contact-return-to');
  if (returnInput) {
    returnInput.value = '/pages/contact' + (window.location.search || '') + '#tcb-contact-form';
  }

  function applyPackagePrefill(value) {
    if (!value) return;
    var ids = String(value)
      .split(/[,;|]/)
      .map(function (part) { return sanitize(part, 80).toLowerCase(); })
      .filter(Boolean);
    if (!ids.length) return;

    document.querySelectorAll('[data-tcb-contact-packages] [data-package-id]').forEach(function (input) {
      var id = (input.getAttribute('data-package-id') || '').toLowerCase();
      if (ids.indexOf(id) >= 0) {
        input.checked = true;
      }
    });

    if (window.TcbContactPackages && window.TcbContactPackages.updateSummary) {
      window.TcbContactPackages.updateSummary();
    }
  }

  function syncPackageTopicState() {
    var packagesField = document.getElementById('tcb-contact-packages-field');
    if (!packagesField || !topicSelect) return;
    var isPackageTopic = topicSelect.value === 'Equipment package quote';
    packagesField.hidden = !isPackageTopic;
    packagesField.classList.toggle('tcb-contact-packages--emphasized', isPackageTopic);
  }

  applyPackagePrefill(getQueryParam('package'));
  applyPackagePrefill(getQueryParam('packages'));

  if (topicSelect) {
    topicSelect.addEventListener('change', syncPackageTopicState);
    syncPackageTopicState();
  }

  var productParam = sanitize(getQueryParam('product'), 200);
  if (productInput && productParam) {
    productInput.value = productParam;
  }

  var fieldMap = {
    company: 'tcb-contact-company',
    first_name: 'tcb-contact-first-name',
    phone: 'tcb-contact-phone'
  };

  Object.keys(fieldMap).forEach(function (key) {
    setFieldValue(fieldMap[key], getQueryParam(key), key === 'phone' ? 40 : 120);
  });

  var emailParam = sanitize(getQueryParam('email'), 254);
  if (emailParam && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailParam)) {
    setFieldValue('tcb-contact-email', emailParam, 254);
  }

  var skuParam = sanitize(getQueryParam('sku'), 120);
  if (productInput && skuParam && !productInput.value) {
    productInput.value = skuParam;
  }

  scrollToForm();
  window.addEventListener('hashchange', function () {
    normalizeContactLanding();
    scrollToForm();
  });

  document.querySelectorAll('[data-tcb-topic]').forEach(function (link) {
    link.addEventListener('click', function () {
      setTopicFromParam(link.getAttribute('data-tcb-topic'));
      if (topicSelect) {
        topicSelect.focus();
      }
      scrollToForm();
    });
  });

  form.addEventListener('submit', function (event) {
    if (honeypotInput && honeypotInput.value.trim()) {
      event.preventDefault();
      return;
    }

    var first = firstNameInput ? sanitize(firstNameInput.value, 80) : '';
    var last = lastNameInput ? sanitize(lastNameInput.value, 80) : '';
    if (fullNameInput) {
      fullNameInput.value = [first, last].filter(Boolean).join(' ');
    }
  });

  if (messageInput && productParam && !sanitize(messageInput.value, 5000)) {
    messageInput.placeholder = 'I have a question about ' + productParam + '…';
  }

  var docLabels = {
    'spec-sheet': 'spec sheet',
    manual: 'manual',
    'parts-list': 'parts list',
    'sell-sheet': 'sell sheet',
    warranty: 'warranty document'
  };

  function applyEmbeddedMode() {
    if (getQueryParam('embedded') !== '1') return;
    document.documentElement.classList.add('tcb-contact-embed');

    var docParam = sanitize(getQueryParam('doc'), 64).toLowerCase();
    if (docParam && messageInput && !sanitize(messageInput.value, 5000)) {
      var label = docLabels[docParam] || docParam.replace(/-/g, ' ');
      messageInput.value = 'Please send the ' + label + ' for this product.';
    }

    var successAlertEmbed = document.querySelector('.tcb-contact-alert--success');
    if (successAlertEmbed) {
      try {
        window.parent.postMessage(
          {
            type: 'tcb-contact-success',
            message: successAlertEmbed.textContent.trim()
          },
          window.location.origin
        );
      } catch (e) {
        /* ignore cross-window failures */
      }
    }
  }

  applyEmbeddedMode();

  if (document.querySelector('.tcb-contact-alert--success') && window.tcbAnalytics && window.tcbAnalytics.formSubmitted) {
    window.tcbAnalytics.formSubmitted('contact_page', topicSelect ? topicSelect.value : '');
  }
});
